/**
 * @file WriteoffNotices.tsx
 * @description Полосы под плитками документа «Списание» (phase19.24 этап 1,
 * шаг 1).
 *
 * Собраны в один компонент по той же причине, что и у сборки
 * (`PickingTaskNotices`): страница документа отвечает за каркас, а не за
 * каскад тернарников. Порядок фиксирован — сначала что написал человек
 * (комментарий), потом что важно знать про остаток.
 */

import { NoticeStrip } from "../ui/NoticeStrip";

interface Props {
  /** Комментарий документа; пусто — полосы нет. */
  notes: string | null;
  /** Черновик — остаток ещё не двигали. */
  isDraft: boolean;
}

export function WriteoffNotices({ notes, isDraft }: Props) {
  return (
    <>
      {notes ? (
        <NoticeStrip tone="info" title="Комментарий">
          {notes}
        </NoticeStrip>
      ) : null}
      {isDraft ? (
        <NoticeStrip tone="info">
          Черновик остаток не двигает: товар спишется только после кнопки
          «Провести списание».
        </NoticeStrip>
      ) : null}
    </>
  );
}
